import api from './api'; 

const API_URL = '/payments/contracts';

// Helper to get headers (assuming you store token in localStorage)
const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
};

const paymentService = {
  getPayments: async (params) => {
    try {
      const response = await api.get(API_URL, { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get a single payment details
  getPaymentById: async (id) => {
    try {
      const response = await api.get(`${API_URL}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Create a new payment
  createPayment: async (paymentData) => {
    try {
      const response = await api.post(API_URL, paymentData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update an existing payment
  updatePayment: async (id, paymentData) => {
    try {
      const response = await api.put(`${API_URL}/${id}`, paymentData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Delete a payment
  deletePayment: async (id) => {
    try {
      const response = await api.delete(`${API_URL}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};

export default paymentService;